//Version 0.96

String.prototype.replaceAt = function (index, replacement) {
    return this.substr(0, index) + replacement + this.substr(index + replacement.length);
}

String.prototype.replaceAll = function(search, replacement) {
    let target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

String.prototype.numberOnly = function () {
    let reg = /\D/g;
    let target = this;
    return target.replaceAll(reg, "");
};

String.prototype.isEmptyString = function () {
    let target = this;
    return(target === null || target.match(/^ *$/) !== null)
};

String.prototype.currencyString = function (language, digit, currencySymbol) {
    let target = this;
    target = target.numberOnly()
    target = Number(target)
    if (digit != null) {
        target = target.toFixed(digit)
    }
    let currencyOption = {}
    if (currencySymbol != null) {
        currencyOption.currency = currencySymbol;
        currencyOption.style = 'currency';
    }
    
    return new Intl.NumberFormat(language, currencyOption).format(target)
}

Number.prototype.currencyString = function (language, digit, currencySymbol) {
    let target = this;
    let currencyOption = {}
    if (digit != null) {
        target = target.toFixed(digit)
    }
    if (currencySymbol != null) {
        currencyOption.currency = currencySymbol;
        currencyOption.style = 'currency';
    }
    return new Intl.NumberFormat(language, currencyOption).format(target)
}

String.prototype.stringSymbolFormat = function (symbolFormat) {
    let reg = /[^x\W]/g;
    symbolFormat = symbolFormat.replaceAll(reg, "");
    let baseString = this;
    let formatIndex = 0;
    let stringIndex = 0;
    let buildString = '';
    while (stringIndex < baseString.length) {
        if (formatIndex < symbolFormat.length) {
            if (symbolFormat[formatIndex] == 'x') {
                buildString += baseString[stringIndex];
                stringIndex++;
            } else {
                buildString += symbolFormat[formatIndex];
            }
            formatIndex++;
        } else {
            break;
        }
    }
    return buildString;
}

window.copyToClipboard = function (text) {
    const elem = document.createElement('textarea');
    elem.value = text;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
}

window.isMobile = function () {
    let check = false;
    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|ie9|ie10|ie11|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i
                .test(a) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
                .test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

window.validateEmail = function (email) {
    let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(email);
}

window.globalOffset = function (el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft
    }
}

window.refreshRenderObj = null;

window.refreshRender = function (forceRefresh,refreshDelay = 150) {
    if (window.refreshRenderObj != null) clearTimeout(window.refreshRenderObj);
    if (forceRefresh != null && forceRefresh == false) return;
    if (window.isMobile() || forceRefresh == true) {
        if (window.refreshRenderObj != null) clearTimeout(window.refreshRenderObj);
        document.querySelectorAll('.base-scroll').forEach((o) => {
            o.classList.add('refreshing');
        });
        window.refreshRenderObj = setTimeout(() => {
            document.querySelectorAll('.base-scroll').forEach((o) => {
                o.classList.remove('refreshing');
            });
        }, refreshDelay);
    }
}

window.displayReduxData = (targetObj, childObj) => {
    if (targetObj != null) {
        let renderData = childObj.split(".");
        let resultData = targetObj[renderData[0]];
        if (resultData == null) return '';
        if (renderData.length > 1) {
            renderData.shift();
            return window.displayReduxData(resultData, renderData.join('.'));
        } else if (renderData.length == 1) {
            return resultData;
        }
    } else {
        return '';
    }
}

window.contentScrollTopRunTime = null;

window.contentScrollTop = (smoothAnimation) => {
    if(!smoothAnimation){
        document.querySelector('.base-frame-scroller').scrollTop = 0;
    }else{
        document.querySelector('.App').classList.add('bypass');
        let animateScroll = 0;
        if(window.contentScrollTopRunTime != null){
            document.querySelector('.App').classList.remove('bypass');
            clearInterval(window.contentScrollTopRunTime);
            window.contentScrollTopRunTime = null;
        }
        let targetObj = document.querySelector('.base-frame-scroller');
        let secondDiff = 50;
        let animatedCal = 0;
        let startCal = targetObj.scrollTop;
        window.contentScrollTopRunTime = setInterval(()=>{
            startCal += (0 - startCal) * (0.1);
            targetObj.scrollTop = startCal;
            animatedCal++;
            if(animatedCal > secondDiff){
                document.querySelector('.App').classList.remove('bypass');
                clearInterval(window.contentScrollTopRunTime);
                window.contentScrollTopRunTime = null;
            }
        },0);
    }
}

window.scrollEndMemory = {};

window.scrollEndSet = (scrollEventId,targetObj,actionFunction,actionFunctionValue,scrollOverRange = 100,mode = '') => {
    if(window.scrollEndMemory[scrollEventId]){
        window.scrollEndRemove(scrollEventId);
    }
    let scrollEndMemoryObj = {};
    scrollEndMemoryObj.scrollEventId = scrollEventId;
    scrollEndMemoryObj.targetObj = targetObj;
    scrollEndMemoryObj.eventFunction = (e) => {
        let scrollObj = e.target;
        if(scrollObj.scrollTop >= ((scrollObj.scrollHeight - scrollObj.clientHeight) - scrollOverRange)){
            if(mode == 'once'){
                window.scrollEndRemove(scrollEndMemoryObj.scrollEventId);
            }
            actionFunction(actionFunctionValue);
        }
    };
    window.scrollEndMemory[scrollEventId] = scrollEndMemoryObj;
    scrollEndMemoryObj.targetObj.addEventListener('scroll',scrollEndMemoryObj.eventFunction);
};

window.scrollEndRemove = (scrollEventId) => {
    if(window.scrollEndMemory[scrollEventId]){
        window.scrollEndMemory[scrollEventId].targetObj.removeEventListener('scroll',window.scrollEndMemory[scrollEventId].eventFunction);
        delete window.scrollEndMemory[scrollEventId];
    }
};

window.autoDate = {
    dateGetRaw: function (rawDate) {
        let onlyNumber = /[0-9]/g;
        let removeOut = /,/g;
        let rawData = rawDate.match(onlyNumber);
        rawData = rawData.join();
        rawData = rawData.replace(removeOut, "");
        return Number(rawData);
    },
    dateNowRaw: function () {
        return new Date().getTime();
    },
    dateRaw: function (date) {
        return date.getTime();
    },
    dateNow: function (format) {
        let dateData = new Date();
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    dateFirst: function (format) {
        let dateData = new Date(0,0,0,0,0,0,0);
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    addDay: function (date, format, addDay) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        dateData.setDate(dateData.getDate() + addDay);
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    addMonth: function (date, format, addMonth) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        dateData.setMonth(dateData.getMonth() + addMonth);
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    addYear: function (date, format, addYear) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        dateData.setYear(dateData.getFullYear() + addYear);
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    setDay: function (date, format, day) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        dateData.setDate(day);
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    setMonth: function (date, format, month) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        dateData.setMonth(month);
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    setYear: function (date, format, year) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        dateData.setYear(year);
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    getDate: function (date, format) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        return dateData.getDate();
    },
    getMonth: function (date, format) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        return dateData.getMonth();
    },
    getYear: function (date, format) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        return dateData.getFullYear();
    },
    getLastDate: function (date, format) {
        let dateData = window.autoDate.parseDate(date, window.autoDate.parseFormat(format));
        dateData = new Date(dateData.getFullYear(), dateData.getMonth() + 1, 0);
        let dateFormat = window.autoDate.parseFormat(format);
        return window.autoDate.formatDate(dateData, dateFormat);
    },
    isLeapYear: function (year) {
        return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0))
    },
    getDaysInMonth: function (year, month) {
        return [31, (window.autoDate.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month]
    },
    parseFormat: function (format) {
        let separator = format.match(/[.\/\-\s].*?/),
            parts = format.split(/\W+/);
        if (!separator || !parts || parts.length === 0) {
            throw new Error("Invalid date format.");
        }
        return { separator: separator, parts: parts };
    },
    parseDate: function (date, format) {
        let parts = date.split(format.separator);
        let val;
        date = new Date()
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        if (parts.length === format.parts.length) {
            let year = date.getFullYear(), day = date.getDate(), month = date.getMonth();
            for (let i = 0, cnt = format.parts.length; i < cnt; i++) {
                val = parseInt(parts[i], 10) || 1;
                switch (format.parts[i]) {
                    case 'dd':
                    case 'd':
                        day = val;
                        date.setDate(val);
                        break;
                    case 'mm':
                    case 'm':
                        month = val - 1;
                        date.setMonth(val - 1);
                        break;
                    case 'yy':
                        year = 2000 + val;
                        date.setFullYear(2000 + val);
                        break;
                    case 'yyyy':
                        year = val;
                        date.setFullYear(val);
                        break;
                }
            }
            date = new Date(year, month, day, 0, 0, 0);
        }
        return date;
    },
    formatDate: function (date, format) {
        let val = {
            d: date.getDate(),
            m: date.getMonth() + 1,
            yy: date.getFullYear().toString().substring(2),
            yyyy: date.getFullYear()
        };
        val.dd = (val.d < 10 ? '0' : '') + val.d;
        val.mm = (val.m < 10 ? '0' : '') + val.m;
        date = [];
        for (let i = 0, cnt = format.parts.length; i < cnt; i++) {
            date.push(val[format.parts[i]]);
        }
        return date.join(format.separator);
    }
};

window.GlobalDataBase = {}

window.GlobalData = function (multiKey,value,chainObj){
    chainObj = chainObj || window.GlobalDataBase;
    let key = multiKey.split('.');
    let chooseKey = key.shift();
    let mixKey = key.join('.');
    let returnData = null;
    
    if(value != null){
        if(key.length == 0){
            chainObj[chooseKey] = value;
        }else{
            chainObj[chooseKey] = window.GlobalData(mixKey,value,chainObj[chooseKey] || {});
        }
        return chainObj;
    }else{
        if(key.length == 0){
            returnData = chainObj[chooseKey];
        }else{
            if(chainObj[chooseKey] != null){
                returnData = window.GlobalData(mixKey,value,chainObj[chooseKey] || {});
            }else{
                returnData = null;
            }
        }
        return returnData;
    }
}

window.ClearGlobalData = function (multiKey="",chainObj=null){
    chainObj = chainObj || window.GlobalDataBase
    let key = multiKey.split('.');
    let chooseKey = key.shift();
    let mixKey = key.join('.')
    let returnData = false;
    if(key.length == 0){
        if(chooseKey == ""){
            window.GlobalDataBase = {}
            returnData = true;
        }else if(chainObj[chooseKey] != null){
            chainObj[chooseKey] = null
            delete chainObj[chooseKey]; 
            returnData = true;
        }
    }else{
        if(chainObj[chooseKey] != null){
            returnData = window.ClearGlobalData(mixKey,chainObj[chooseKey] || {})
        }else{
            returnData = false;
        }
    }
    return returnData;
}

window.GlobalEventBase = {}

window.GlobalEvent = function (eventGroupId,eventType,eventFunction,attachObject){
    if(window.GlobalEventBase[eventGroupId] == null) {
        window.GlobalEventBase[eventGroupId] = [];
    }
    window.GlobalEventBase[eventGroupId].push({ event: eventType, func: eventFunction, obj: attachObject });
    if (attachObject != null) {
        attachObject.addEventListener(window.GlobalEventBase[eventGroupId][window.GlobalEventBase[eventGroupId].length - 1].event, window.GlobalEventBase[eventGroupId][window.GlobalEventBase[eventGroupId].length - 1].func);
    } else {
        window.addEventListener(window.GlobalEventBase[eventGroupId][window.GlobalEventBase[eventGroupId].length - 1].event, window.GlobalEventBase[eventGroupId][window.GlobalEventBase[eventGroupId].length - 1].func);
    }
}

window.ClearGlobalEvent = function (eventGroupId){
    if(eventGroupId != null) {
        let eventList = window.GlobalEventBase[eventGroupId];
        if (eventList != null){
            for (let F = 0; F < eventList.length; F++){
                if (eventList[F].obj != null) {
                    eventList[F].obj.removeEventListener(eventList[F].event, eventList[F].func);
                } else {
                    window.removeEventListener(eventList[F].event, eventList[F].func);
                }
            }
            window.GlobalEventBase[eventGroupId] = null
            delete window.GlobalEventBase[eventGroupId]; 
        }
    }else{
        let eventList = Object.keys(window.GlobalEventBase);
        for(let F = 0;F < eventList.length;F++){
            window.ClearGlobalEvent(window.GlobalEventBase[eventList[F]]);
        }
    }
}

window.GlobalSwitchLanguage = {
    Current: 'en',
    TargetClass: 'cc-lang',
    Init: function () {
        let LanguageObjList = document.querySelectorAll('.' + window.GlobalSwitchLanguage.TargetClass)
        for (let F = 0; F < LanguageObjList.length; F++) {
            LanguageObjList[F].setAttribute('cc-lang', LanguageObjList[F].textContent)
            let PlaceHolder = LanguageObjList[F].getAttribute('placeholder')
            if (PlaceHolder != false) {
                LanguageObjList[F].setAttribute('cc-lang-ph', PlaceHolder)
            }
            window.GlobalSwitchLanguage.Translate()
        }
    },
    Translate: function (Language) {
        window.GlobalSwitchLanguage.Current = Language || window.GlobalSwitchLanguage.Current
        let LanguageObjList = document.querySelectorAll('.' + window.GlobalSwitchLanguage.TargetClass)
        for (let F = 0; F < LanguageObjList.length; F++) {
            let CurrentWordNode = LanguageObjList[F].getAttribute('cc-lang')
            if (CurrentWordNode != null && CurrentWordNode != false) LanguageObjList[F].innerHTML = window.GlobalSwitchLanguage.FindLanguageNode(CurrentWordNode)
            let CurrentWordPHNode = LanguageObjList[F].getAttribute('cc-lang-ph')
            if (CurrentWordNode != null && CurrentWordPHNode != false) LanguageObjList[F].setAttribute('placeholder', window.GlobalSwitchLanguage.FindLanguageNode(CurrentWordPHNode))
        }
    },
    FindLanguageNode: function (Base) {
        let ReturnResult = (window.GlobalSwitchLanguage.Words[window.GlobalSwitchLanguage.Current] != null ? window.GlobalSwitchLanguage.RuntimeLanguageNode(window.GlobalSwitchLanguage.Words[window.GlobalSwitchLanguage.Current], Base) : null)
        if (ReturnResult == null) return Base
        return ReturnResult
    },
    RuntimeLanguageNode: function (Base, Relative) {
        let ReturnResult = null
        let WordNodeArray = Relative.split(".")
        let WordNode = WordNodeArray.shift()
        Relative = WordNodeArray.join(".")
        if (WordNodeArray.length > 0) {
            ReturnResult = (Base[WordNode] != null ? window.GlobalSwitchLanguage.RuntimeLanguageNode(Base[WordNode], Relative) : null)
        } else if (WordNodeArray.length == 0) {
            ReturnResult = (Base[WordNode] != null ? Base[WordNode] : null)
        }
        return ReturnResult
    },
    Words: {
        ["en"]: { },
        ["th"]: { }
    }
}

window.GlobalRequest = {
    QueueCurrent: 0,
    QueueCount: 0,
    CalculateGetDataObject: function (UrlPath, ObjectData, Path, FormDataObj) {
        let GetDataBase = FormDataObj || new URL(UrlPath)

        if (ObjectData instanceof File) {
            let PathObj = (Path != null ? JSON.parse(JSON.stringify(Path)) : [])
            GetDataBase.append(PathObj.join('.'), ObjectData)
        } else if (Array.isArray(ObjectData)) {
            for (var F = 0; F < ObjectData.length; F++) {
                let PathObj = (Path != null ? JSON.parse(JSON.stringify(Path)) : [])
                PathObj[PathObj.length - 1] = PathObj[PathObj.length - 1] + '[' + F + ']'
                GetDataBase = window.GlobalRequest.CalculateGetDataObject(UrlPath, ObjectData[F], PathObj, GetDataBase) || GetDataBase
            }
        } else if (typeof ObjectData === 'function' && ObjectData != null) {
            return null
        } else if (typeof ObjectData === 'object' && ObjectData != null) {
            for (var Key in ObjectData) {
                if (ObjectData.hasOwnProperty(Key)) {
                    let PathObj = (Path != null ? JSON.parse(JSON.stringify(Path)) : [])
                    PathObj.push(Key)
                    GetDataBase = window.GlobalRequest.CalculateGetDataObject(UrlPath, ObjectData[Key], PathObj, GetDataBase) || GetDataBase
                }
            }
        } else {
            let PathObj = (Path != null ? JSON.parse(JSON.stringify(Path)) : [])
            GetDataBase.searchParams.append(PathObj.join('.'), ObjectData);
        }
        return GetDataBase
    },
    CalculateFormDataObject: function (ObjectData, Path, FormDataObj) {
        let FormDataBase = FormDataObj || new FormData()

        if (ObjectData instanceof File) {
            let PathObj = (Path != null ? JSON.parse(JSON.stringify(Path)) : [])
            FormDataBase.append(PathObj.join('.'), ObjectData)
        } else if (Array.isArray(ObjectData)) {
            for (var F = 0; F < ObjectData.length; F++) {
                let PathObj = (Path != null ? JSON.parse(JSON.stringify(Path)) : [])
                PathObj[PathObj.length - 1] = PathObj[PathObj.length - 1] + '[' + F + ']'
                FormDataBase = window.GlobalRequest.CalculateFormDataObject(ObjectData[F], PathObj, FormDataBase) || FormDataBase
            }
        } else if (typeof ObjectData === 'function' && ObjectData != null) {
            return null
        } else if (typeof ObjectData === 'object' && ObjectData != null) {
            for (var Key in ObjectData) {
                if (ObjectData.hasOwnProperty(Key)) {
                    let PathObj = (Path != null ? JSON.parse(JSON.stringify(Path)) : [])
                    PathObj.push(Key)
                    FormDataBase = window.GlobalRequest.CalculateFormDataObject(ObjectData[Key], PathObj, FormDataBase) || FormDataBase
                }
            }
        } else if (ObjectData != null) {
            let PathObj = (Path != null ? JSON.parse(JSON.stringify(Path)) : [])
            FormDataBase.append(PathObj.join('.'), ObjectData)
        }
        return FormDataBase
    },
    Token: null,
    Request: function (Type, UrlPath, Param, Callback) {
        window.GlobalRequest.QueueCount += 1
        let Request = new XMLHttpRequest()
        Request.onreadystatechange = function () {
            window.GlobalRequest.Listener(Request, Callback)
        }
        if (Type == 'GET') {
            let GetObj = window.GlobalRequest.CalculateGetDataObject(UrlPath, Param)
            UrlPath = GetObj.href
        }
        Request.open(Type, UrlPath, true)
        Request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
        if (window.GlobalRequest.Token != null) Request.setRequestHeader("Authorization", "Bearer " + window.GlobalRequest.Token)

        Request.send(JSON.stringify(Param || {}))
    },
    RequestForm: function (Type, UrlPath, Param, Callback) {
        window.GlobalRequest.QueueCount += 1

        let FormObj = window.GlobalRequest.CalculateFormDataObject(Param)

        let Request = new XMLHttpRequest()
        Request.onreadystatechange = function () {
            window.GlobalRequest.Listener(Request, Callback)
        }
        if (Type == 'GET') {
            let GetObj = window.GlobalRequest.CalculateGetDataObject(UrlPath, Param)
            UrlPath = GetObj.href
        }
        Request.open(Type, UrlPath, true)
        if (window.GlobalRequest.Token != null) Request.setRequestHeader("Authorization", "Bearer " + window.GlobalRequest.Token)

        Request.send(FormObj)
    },
    Listener: function (RequestData, Callback) {
        window.GlobalRequest.QueueCurrent += 1
        if (Callback != null) Callback(RequestData)
        if (window.GlobalRequest.QueueCurrent >= window.GlobalRequest.QueueCount) {
            window.GlobalRequest.QueueCurrent = 0
            window.GlobalRequest.QueueCount = 0
            if (window.GlobalRequest.AllDoneCallback != null) window.GlobalRequest.AllDoneCallback() 
        }
    },
    AllDoneCallback: null
}